import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { ToasterService } from 'angular2-toaster';
import { AnalyticsService } from '../../../../services/analytics.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Output() onResetPasswordDialog = new EventEmitter();
  @Output() onLoginSuccess = new EventEmitter();
  @Output() onCreateANewAccount = new EventEmitter();
  email: string;
  password: string;
  firstName: string = 'User';

  constructor(
    private auth: AuthService,
    private toasterService: ToasterService,
    private analyticsService: AnalyticsService
  ) {}

  showToast(type: string, title: string, body: string) {
    this.toasterService.popAsync(type, title, body);
  }

  signIn() {
    this.auth.login(this.email, this.password).subscribe(
      token => {
        // console.log('token', token);

        if (token.statusCode === 401) {
          this.showToast('error', 'Login failed', 'Wrong email or password');
        }

        this.auth.setUser(token.user);
        this.auth.setToken(token.id);

        if (token.hasOwnProperty('userId')) {
          // console.log('Sign in: isAuthorization = true');
          if (token.hasOwnProperty('role')) {
            this.auth.setRole(token.role.name);
          } else {
            this.auth.setRole('user');
          }

          this.auth.setIsAuthorization(true);
          this.firstName = token.user.firstName;

          this.auth.setEmail(token.user.email);
          this.auth.setUserId(token.userId);
          sessionStorage.setItem('token', JSON.stringify(token));
          sessionStorage.setItem('isAuthorization', JSON.stringify(true));

          this.onLoginSuccess.emit(token);
          this.analyticsService.onUserLoggedIn(this.auth.userId);
        }
      },
      err => {
        this.showToast('error', 'Login failed', 'Wrong email or password');
      }
    );
  }

  onOpenResetPasswordDialog(): void {
    this.onResetPasswordDialog.emit(true);
  }

  onOpenCreateANewAccount(): void {
    this.onCreateANewAccount.emit(true);
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/common/login-register/login/login.component.ts